import ModelFactoryModel, {IModelFactoryModels} from "./ModelFactoryModel";
import ModelFactoryChoice, {IModelFactoryChoices} from "./ModelFactoryChoice";
import {FactoryID} from "../type-interface/ModelFactoryType";
import {IPopulateIDs} from "../type-interface/ModelFactoryInterface";
import ModelFactoryService from "./ModelFactoryService";
import {IAnyObject} from "../../common/SimpleInterface";
import {cloneObject, isBool, keySort} from "../../common/SiteHelper";

export default class BasicModelFactory
{
    id: FactoryID = "none";

    service?: ModelFactoryService;

    conditionModels: IModelFactoryModels = {};

    choices: IModelFactoryChoices = {};

    isUserDependant: boolean = false;

    constructor()
    {
        this.service = this.birthService();
    }

    birthService(): ModelFactoryService
    {
        return new ModelFactoryService();
    }

    birth(modelID: string): ModelFactoryModel
    {
        return new ModelFactoryModel(modelID);
    }

    birthChoice(choiceID?:string): ModelFactoryChoice
    {
        return new ModelFactoryChoice(choiceID);
    }

    requireModel(populateIDs: IPopulateIDs): ModelFactoryModel
    {
        let modelID = this.createFactoryModelID(populateIDs);
        if(!this.conditionModels[modelID]){
            this.conditionModels[modelID] = this.prepareClonedModel(populateIDs, modelID);
        }
        return this.conditionModels[modelID];
    }

    createFactoryModelID(populateIDs: IPopulateIDs): string
    {
        let factoryModelID:string = this.id;
        let values:IAnyObject = cloneObject(populateIDs);
        values = keySort(values);
        for(let key in values){
            let value = values[key];
            if((value ?? null) === null){
                continue;
            }
            if(isBool(value)){
                value = value ? 1 : 0;
            }
            factoryModelID += "&" + key + "=" + value;
        }
        return factoryModelID;
    }

    prepareClonedModel(populateIDs: IPopulateIDs, modelID?:string): ModelFactoryModel
    {
        if(!modelID){
            modelID = this.createFactoryModelID(populateIDs);
        }
        let model:ModelFactoryModel = this.birth(modelID);
        model.factoryID = this.id;
        model.populateIDs = cloneObject(populateIDs) as IPopulateIDs;
        for(let key in model.populateIDs){
            if((model.populateIDs[key] ?? null) === null){
                delete model.populateIDs[key];
            }
        }
        model.applyModelConditions();
        model.onModelConditionsApplied();
        return model;
    }

    reset(){
        for(let modelID in this.conditionModels){
            const model = this.conditionModels[modelID];
            model.destroy();
        }
        this.conditionModels = {};
    }
}